import React, { FC } from 'react';
import { IconButton, TextField } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Contact } from 'src/types/supplier';

interface Props {
  contact: Contact;
  index: number;
  onRemove: (index: number) => void;
  onChange: (index: number, field: string, value: string) => void;
}

const component: FC<Props> = ({ contact, index, onRemove, onChange }) => {
  return (
    <div
      style={{
        border: '1px solid #000000',
        borderRadius: 4,
        padding: 10,
        margin: '10px 0',
        position: 'relative'
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={4}>
          <TextField
            margin="dense"
            label="Contact Name"
            fullWidth
            variant="outlined"
            value={contact.name}
            onChange={(e) => onChange(index, 'name', e.target.value)}
            style={{ fontSize: 8 }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            margin="dense"
            label="Contact No."
            fullWidth
            variant="outlined"
            value={contact.contact_no}
            onChange={(e) => {
              const value = e.target.value;
              if (/^\d*$/.test(value) && value.length <= 11) {
                onChange(index, 'contact_no', value);
              }
            }}
            inputProps={{
              maxLength: 11,
              inputMode: 'numeric',
              pattern: '[0-9]*'
            }}
            style={{ fontSize: 8 }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            margin="dense"
            label="Email Address"
            fullWidth
            variant="outlined"
            value={contact.email}
            onChange={(e) => onChange(index, 'email', e.target.value)}
            style={{ fontSize: 8 }}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          <IconButton
            size="small"
            onClick={() => onRemove(index)}
            style={{ marginLeft: 'auto' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
    </div>
  );
};

export const ContactField = React.memo(component);
